<template lang="html">
   <div class="s-top-nav clearfix">
      <Modal 
         :show="showChangePassword" 
         :loading="loading" 
         :icon="User.forms.change_password.icon" 
         :title="User.forms.change_password.title" 
         :subtitle="User.forms.change_password.subtitle" 
         @close="$store.commit('showChangePassword',false)"
         @submit="changePassword({ref: $refs[User.forms.change_password.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="User.forms.change_password.name" 
               :forms="User.forms.change_password.forms" 
               :form_data="User.forms.change_password.data"
            />
         </template>
      </Modal>

      <div class="left">
         <div class="header">
            <div class="navTrigger">
               <i></i><i></i><i></i>
            </div>
         </div>
      </div>
      <div class="right">
         <Dropdown 
            class="dropdown fx-dropdown"
            trigger="click"
            placement="left-start"
         >
            <div class="fx-nav-item dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               <img src="/img/avatars/2.png" alt="" class="p-image" data-toggle="tooltip" title="Profile">
            </div>

            <DropdownMenu slot="list" class="profile">
               <div class="profile-details" v-if="user">
                  <img src="/img/avatars/2.png" alt="">
                  <div class="prof-title">{{`${user.names}`}}</div>
                  <div class="subtitle">{{user.role}}</div>
               </div>

               
               <DropdownItem>
                  <div class="action clearfix" @click="showChangePasswordModal()">
                     <div class="fa fa-life-ring"></div>
                     <div class="title">Change Password</div>
                  </div>
               </DropdownItem>
               <DropdownItem>
                  <div class="action clearfix" @click="logOut()">
                     <div class="fa fa-power-off"></div>
                     <div class="title">Sign Out</div>
                  </div>
               </DropdownItem>
            </DropdownMenu>
         </Dropdown>
      </div>
   </div>
</template>

<script>
import user from "../portal/rsc/stores/user.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('user')
   },
   created(){
      utils.registerModule('user',user,this.$store)
   },
   components:{
      Dropdown: () => import("@/libs/clarks/components/dropdown/dropdown"),
      DropdownItem: () => import("@/libs/clarks/components/dropdown/dropdown-item"),
      DropdownMenu: () => import("@/libs/clarks/components/dropdown/dropdown-menu"),
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
   },
   computed: {
      ...mapGetters([
         'User',
         'users',
         'showChangePassword',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'changePassword',
      ]),
      openActions () {
         EventBus.$emit('actions:open')
      },
      async logOut(){
         await $session.clear()
         this.$router.push({name: 'LogIn'})
      },
      showChangePasswordModal(){
         this.$store.commit('showChangePassword', true)
      }
   },
   data () {
      return {
         user: null,
      }
   },
   async mounted(){
      utils.registerModule('user',user,this.$store)
      this.user = await $session.get('user')
   }
}
</script>

<style lang="scss">
   .s-top-nav{
      
   }
</style>